import { api, ENDPOINTS } from '../config';
import type { DeviceFilters, DevicesResponseData, ManualControlParams, BatchControlResult } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getDevices(filters?: DeviceFilters): Promise<DevicesResponseData> {
  const response = await api.get(ENDPOINTS.DEVICES, {
    params: filters,
  });
  
  return response.data;
}

/**
 * Control a device with the manual control endpoint
 * @param params The manual control parameters
 */
export async function manualControlDevice(params: ManualControlParams): Promise<{ success: boolean }> {
  const response = await api.post(ENDPOINTS.MANUAL_CONTROL, params);
  
  return response.data;
}

/**
 * Batch control multiple devices with a single API call
 * @param params Array of manual control parameters
 */
export async function batchControlDevices(params: ManualControlParams[]): Promise<{ results: BatchControlResult[] }> {
  // The endpoint needs to have the slash at the end but not within the "batch/" part
  const endpoint = ENDPOINTS.MANUAL_CONTROL.endsWith('/') 
    ? `${ENDPOINTS.MANUAL_CONTROL.slice(0, -1)}/batch/` 
    : `${ENDPOINTS.MANUAL_CONTROL}/batch/`;
    
  try {
    const response = await api.post(endpoint, {
      batch: params
    });
    
    // Ensure we always have a results array, even if the API response format is unexpected
    if (!response.data || !response.data.results) {
      console.warn('Unexpected batch response format:', response.data);
      // If we get a response but not in the expected format, 
      // assume it worked and create a synthetic response
      return {
        results: params.map((p, index) => ({
          id: index,
          site_id: '',
          device_id: p.device_id,
          action_group_id: null,
          datapoint: p.datapoint,
          value: typeof p.value === 'number' ? p.value : 0,
          command_type: 'manual',
          execute_at: new Date().toISOString(),
          priority: 1,
          source: 'manual',
          status: 'pending',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          passing_conditions: null,
          reconsider_policy: null
        }))
      };
    }
    
    return response.data;
  } catch (error) {
    console.error('Batch control error:', error);
    throw error;
  }
}